import client from "../../../api/apiclient";

const customerProfileAPI = {
    getCustomerProfileInfo: client.createRequestMethod('get', '/api/recipientprofile/GetCustomerProfileQuestions'),
    saveCustomerProfileInfo: client.createRequestMethod(
        'post',
        '/api/recipientprofile/SaveCustomerProfileQuestions'
    )
};

export default customerProfileAPI;